import React, { useState } from "react";
import { motion } from "framer-motion";
import "./Contact.css";

const Contact = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.target;
    const data = new FormData(form);

    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(data).toString(),
    })
      .then(() => setIsSubmitted(true))
      .catch((error) => alert(error));
  };

  return (
    <section id="contact">
      <motion.div
        className="section-heading"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.4 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      >
        <span className="eyebrow">05 — Contact</span>
        <h2 className="display">
          Get <em>in touch.</em>
        </h2>
      </motion.div>

      <motion.div
        className="contact-grid"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.2 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      >
        <aside className="contact-aside">
          <p className="contact-blurb">
            For roles, collaborations, or a coffee — drop a line. I read
            everything.
          </p>
          <div className="contact-direct">
            <span className="eyebrow">Direct</span>
            <a
              href="mailto:eduardonunez.eng@gmail.com"
              className="contact-email"
            >
              eduardonunez.eng@gmail.com
            </a>
          </div>
          <div className="contact-direct">
            <span className="eyebrow">Elsewhere</span>
            <div className="contact-elsewhere">
              <a
                href="https://www.linkedin.com/in/eduardong"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-link"
              >
                LinkedIn ↗
              </a>
              <a
                href="https://github.com/eddayyy"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-link"
              >
                GitHub ↗
              </a>
            </div>
          </div>
        </aside>

        <div className="contact-form-wrap">
          {isSubmitted ? (
            <p className="contact-success">
              Thanks — your message landed. I'll get back as soon as I can.
            </p>
          ) : (
            <form
              className="contact-form"
              name="contact"
              method="POST"
              data-netlify="true"
              data-netlify-honeypot="bot-field"
              onSubmit={handleSubmit}
            >
              <input type="hidden" name="form-name" value="contact" />
              <div className="form-row">
                <label htmlFor="name" className="form-label">
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  className="form-input"
                />
              </div>
              <div className="form-row">
                <label htmlFor="email" className="form-label">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  className="form-input"
                />
              </div>
              <div className="form-row">
                <label htmlFor="message" className="form-label">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  required
                  className="form-input form-textarea"
                />
              </div>
              <button type="submit" className="form-submit">
                Send message <span className="form-submit-arrow">→</span>
              </button>
            </form>
          )}
        </div>
      </motion.div>
    </section>
  );
};

export default Contact;
